"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Svg = _interopRequireDefault(require("../Svg"));
const Image = ({
  height = 150,
  width = 300,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(_Svg.default, (0, _extends2.default)({}, props, {
    height: height,
    width: width
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "6",
    ry: "6",
    width: "100%",
    height: "100%"
  }));
};
var _default = exports.default = Image;